import { produce } from "immer"
const initialState = {
    data: {
        all: {},
        approve: {},
        pending: {},
        reject: {},
        trend: {},

    }
}

export const AdminManageReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'Fetch_Admin_Manage_List':
            return produce(state, (draft) => {

                const { type, data } = action.payload;
                if (type && draft.data.hasOwnProperty(type)) {
                    draft.data[type] = data;
                }
            })


        default:
            return state

    }
}